import { FC } from 'react';

export const DocumentAdd: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7 4C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V9.41421L12.5858 4H7ZM4 5C4 3.34315 5.34315 2 7 2H12.5858C13.1162 2 13.6249 2.21071 14 2.58579L19.4142 8C19.7893 8.37507 20 8.88378 20 9.41421V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V5ZM12 9.5C12.5523 9.5 13 9.94772 13 10.5V12H14.5C15.0523 12 15.5 12.4477 15.5 13C15.5 13.5523 15.0523 14 14.5 14H13V15.5C13 16.0523 12.5523 16.5 12 16.5C11.4477 16.5 11 16.0523 11 15.5V14H9.5C8.94772 14 8.5 13.5523 8.5 13C8.5 12.4477 8.94772 12 9.5 12H11V10.5C11 9.94772 11.4477 9.5 12 9.5Z"
			fill="currentColor"
		/>
	</svg>
);
